module.exports = __webpack_public_path__ + "static/media/flaskbot.b48f821c.png";